module.exports = __webpack_public_path__ + "img/clientapplicationform.2215cb57.jpg";